import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Preview from '../views/Preview'
import ForceEditView from '../views/ForceEditView'
import SampleUpdateAnswer from '../views/SampleUpdateAnswer'
import InvestigatorEdit from '../views/InvestigatorEdit'
import Study from '../views/Study.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/home'
  },
  {
    path: '/home',
    name: 'Home',
    component: Home
  },
  {
    path: '/study',
    name: 'Study',
    component: Study
  },
  {
    path: '/preview/:id',
    name: 'preview',
    component: Preview
  },
  {
    path: '/force-edit-view/:id',
    name: 'forceEditView',
    component: ForceEditView
  },
  {
    path: '/sample-update-answer/:id',
    name: 'sampleUpdateAnswer',
    component: SampleUpdateAnswer
  },
  {
    path: '/investigator-edit/:id',
    name: 'InvestigatorEdit',
    component: InvestigatorEdit
  }
  // {
  //   path: '/about',
  //   name: 'About',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  // }
]

const router = new VueRouter({
  routes
})

export default router
